import { defineComponent as _defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables';
    import { THGTag } from '@/interfaces/thg/THGTag';
    import { confirm } from '@/utils/dialogs';
    import emitter from '@/utils/mitt';
    import { deleteTHGTag } from '@/api/thg/tags';

    interface Props {
        data?: THGTag[];
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'GenericTHGTagTable',
  props: {
    data: null
  },
  emits: ["dataReloading"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'dataReloading'): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        data?: THGTag[];
    };

    const router = useRouter();
    const route = useRoute();

    

    

    function edit(tagId: string) {
        router.push({
            name: 'thgtag',
            params: { tagId: tagId, prevRouteName: route.name as string },
        });
    }

    async function deleteTag(tagObj: THGTag) {
        if (!tagObj._id) {
            throw new Error('Tag ID is undefined.');
        }

        const question = `Soll der ausgewählte Tag ${tagObj.name} wirklich gelöscht werden?`;
        const { result, dialog } = await confirm('Tag löschen', question, 'Löschen', 'is-danger');

        if (result) {
            // start loading
            emitter.emit('showLoader');

            // do the actual delete operation
            await deleteTHGTag(tagObj._id);

            // close dialog and re-fetch data
            dialog.close();

            // emit the dataReloading event and close the loader
            emit('dataReloading');
            emitter.emit('hideLoader');
        }
    }

return { __sfc: true,router, route, emit, props, edit, deleteTag }
}

})